export const submitLead = async (payload) => {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("send failed");
  return res.json();
};
